import { useEffect } from "react";
import { premium_month, premium_year, pro_month, pro_year } from "./constants";

export const useApplyCoupon = (
  planParam,
  setProMonthUpgradeModal,
  setProUpgradeModal,
  setPremiumMonthUpgradeModal,
  setPremiumUpgradeModal,
  setMonthlyPro,
  setMonthlyPremium,
) => {
  useEffect(() => {
    if (planParam === pro_month) {
      setMonthlyPro(true);
      setProMonthUpgradeModal(true);
    } else if (planParam === pro_year) {
      setProUpgradeModal(true);
    } else if (planParam === premium_month) {
      setMonthlyPremium(true);
      setPremiumMonthUpgradeModal(true);
    } else if (planParam === premium_year) {
      setPremiumUpgradeModal(true);
    }
  }, []);
};
